import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@mui/material/styles';
import App from './App.jsx';
import { ApiContext } from './ApiContext';
import { API_BASE, INDICATOR } from './config';
import { useEffectOnce } from 'usehooks-ts';
import { inputsState, mapState } from './state.js';

export default function Root({ theme, options = {} }) {
  const {
    apiBase = API_BASE,
    indicator = INDICATOR,
    inputsStateDefault = {},
    mapStateDefault = {},
  } = options;

  const setDefaultValues = (defaultValues, stateValues) => {
    for (const [key] of Object.entries(stateValues)) {
      if (key in defaultValues) stateValues[key] = defaultValues[key];
    }
  };

  useEffectOnce(() => {
    setDefaultValues(inputsStateDefault, inputsState);
    setDefaultValues(mapStateDefault, mapState);
  });

  return (
    <React.StrictMode>
      <ApiContext.Provider
        value={{
          apiBase,
          indicator,
        }}
      >
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </ApiContext.Provider>
    </React.StrictMode>
  );
}

Root.propTypes = {
  theme: PropTypes.object.isRequired,
  options: PropTypes.object,
};
